module.exports = __webpack_public_path__ + "img/index-security-bottom3.67cd1032.svg";